import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53437520"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-8" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center mb-10" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-circle icon" })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-center mb-6" }, "Pedido gerado com sucesso!", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fs-6 text-center" }, " Aqui está o seu código Pix! Faça o pagamento para que o pedido seja concluído. Você receberá um e-mail assim que o pagamento for confirmado e o conteúdo liberado. ", -1))
const _hoisted_5 = { class: "row mt-8" }
const _hoisted_6 = { class: "col-4" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "col-8" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fs-6" }, [
  /*#__PURE__*/_createTextVNode(" Abra o aplicativo do seu banco e selecione a opção Pix com QR Code e leia o código ao lado, "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("ou copie o código abaixo e cole na opção Pix Copia e Cola. ")
], -1))
const _hoisted_10 = { class: "qr-code d-none d-lg-flex" }
const _hoisted_11 = ["value"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  class: "bi bi-files"
}
const _hoisted_14 = {
  key: 1,
  class: "bi bi-check-circle-fill"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Copy ")
const _hoisted_16 = { class: "d-block d-lg-none mt-5" }
const _hoisted_17 = { class: "qr-code" }
const _hoisted_18 = ["value"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 0,
  class: "bi bi-files"
}
const _hoisted_21 = {
  key: 1,
  class: "bi bi-check-circle-fill"
}
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Copy ")

import {useStore} from "vuex";
import {ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()

const copiedStatus = ref(false)

const copyCode = () =>{
  navigator.clipboard.writeText(store.getters.getPix.text)
  copiedStatus.value = true
  setTimeout(()=>{
    copiedStatus.value = false
  }, 5000)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("img", {
          class: "qr-code-img",
          src: _unref(store).getters.getPix.pix,
          alt: "QR_CODE"
        }, null, 8, _hoisted_7)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("input", {
              type: "text",
              readonly: "",
              value: _unref(store).getters.getPix.text
            }, null, 8, _hoisted_11),
            _createElementVNode("button", {
              type: "button",
              onClick: _withModifiers(copyCode, ["stop"])
            }, [
              (!copiedStatus.value)
                ? (_openBlock(), _createElementBlock("i", _hoisted_13))
                : (_openBlock(), _createElementBlock("i", _hoisted_14)),
              _hoisted_15
            ], 8, _hoisted_12)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("input", {
          type: "text",
          readonly: "",
          value: _unref(store).getters.getPix.text
        }, null, 8, _hoisted_18),
        _createElementVNode("button", {
          type: "button",
          onClick: _withModifiers(copyCode, ["stop"])
        }, [
          (!copiedStatus.value)
            ? (_openBlock(), _createElementBlock("i", _hoisted_20))
            : (_openBlock(), _createElementBlock("i", _hoisted_21)),
          _hoisted_22
        ], 8, _hoisted_19)
      ])
    ])
  ]))
}
}

})